import { render, staticRenderFns } from "./KnowledgeBanner.vue?vue&type=template&id=02a7c5ce&scoped=true"
var script = {}
import style0 from "./KnowledgeBanner.vue?vue&type=style&index=0&id=02a7c5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a7c5ce",
  null
  
)

export default component.exports